import { render, staticRenderFns } from "./areaRecordingWeeks.vue?vue&type=template&id=cfbb5b98&"
import script from "./areaRecordingWeeks.vue?vue&type=script&lang=js&"
export * from "./areaRecordingWeeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports